import { viralWidgetSettingsSchema } from "@redotech/redo-conversion-core-common/viral/viral-widget";
import * as z from "zod";

export const viralWidgetRowSchema = viralWidgetSettingsSchema.extend({
  createdAt: z.coerce.date(),
});
export interface ViralWidgetRow extends z.infer<typeof viralWidgetRowSchema> {}

export const getViralWidget = {
  name: "getViralWidget" as const,
  description:
    "Returns the team's Thank You page viral widget config, or null if the team has not created one. Takes no input; team is derived from the session.",
  input: z.object({}),
  output: viralWidgetRowSchema.nullable(),
};
